import { SelectSuggestTypes, useIntl } from 'platform-components';
import React from 'react';

//@ts-ignore
import FormView from 'common.components/form-view/form-view';

import { LocalityData } from '../typings';

interface Props {
    canChangeData: boolean;
    localityData: LocalityData;
}

export const CertificateModalLocality = ({
    localityData: {
        handleLocalityChange,
        handleValidateLocality,
        locality,
        localityErrorMessage,
        localities,
        handleLocalityInputChange,
    },
    canChangeData,
}: Props) => {
    const intl = useIntl();

    return (
        <FormView.Suggest
            disabled={!canChangeData}
            errorMessage={localityErrorMessage}
            labelKey="title"
            mix="certificate-modal__form-select"
            onBlur={handleValidateLocality}
            onChange={handleLocalityChange}
            onInputChange={handleLocalityInputChange}
            options={localities}
            placeholder={intl.formatMessage({ id: 'certificatesModal.form.locality' })}
            type={SelectSuggestTypes.INPUT}
            value={locality && locality.id}
            valueKey="id"
        />
    );
};
